import { apiNodeSimulador } from "./apiNode";
import { api as apiPHP } from "./api";

const apiNodeEnabled = localStorage.getItem("NODEJS_API") || "YES";

console.log("apinode", apiNodeEnabled);

export const proxyApi = apiNodeEnabled === "YES" ? apiNodeSimulador : apiPHP;
